import { Fragment, useEffect, useState } from "react";
import moment from "moment";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";

import { TokenService } from "../../he-thong/chung-thu-so/TokenService";
import { LoadingService } from "../../../AppLoading";

import { InvoiceListService } from "../InvoiceListService";

import { useToolbar } from "../../../shared/hooks/Toolbar";
import { useDataTable } from "../../../shared/hooks/DataTable";

import { useSign } from "../../../shared/component/Sign";

import { useForm } from "../../../shared/hooks/Form";

import { ConfirmDialogService } from "../../../AppConfirmDialog";
import DialogBangKe from "../components/DialogBangKe";
import { RegisterInvoiceService } from "../../../service/invoice/RegisterInvoiceService";
import { isInvoiceLinkedStatement } from "../../../utils/invoiceListLink";
import { DialogCrup } from "../../hoa-don/component/DialogCrup";
import { InvoiceService } from "../../hoa-don/InvoiceService";
import { CurrencyService } from "../../danh-muc/tien-te/CurrencyService";
import { ServerTimeService } from "../../../service/ServerTimeService";

const linkedStatementMessages = {
  edit: "Bảng kê đã được liên kết với hóa đơn nên không được phép sửa.",
  delete: "Bảng kê đã được liên kết với hóa đơn nên không được phép xóa.",
};

export const List = () => {
  const header = "Bảng kê";
  const dataKey = "id";

  const [displayBangKe, setDisplayBangKe] = useState(false);
  const [displayCrup, setDisplayCrup] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [registerInvoice, setRegisterInvoice] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [showIconSign, setShowIconSign] = useState(false);
  const [invoiceStatus, setInvoiceStatus] = useState(null);

  const [pdf, setPdf] = useState(null);
  const [displayPdf, setDisplayPdf] = useState(null);

  const [submitting, setSubmitting] = useState(false);
  const [displayFile, setDisplayFile] = useState(null);

  const [selectedInvoiceListId, setSelectedInvoiceListId] = useState(null);
  const [registerInvoices, setRegisterInvoices] = useState([]);
  const [invoiceListRequiredParams, setInvoiceListRequiredParams] = useState({
    InvoiceType: 2,
  });

  const statuses = [
    { value: 0, label: "Chờ duyệt" },
    { value: 1, label: "Chờ ký" },
    { value: 2, label: "Đã ký" },
    { value: 3, label: "Đang gửi" },
    { value: 4, label: "Thành công" },
    { value: 5, label: "Có lỗi" },
    { value: 6, label: "Đang ký" },
  ];

  const invoiceListTypes = [
    { value: 2, label: "Điều chỉnh" },
    { value: 1, label: "Thay thế" },
  ];

  const getStatus = (status) =>
    statuses.find((item) => item.value === status);

  const getListType = (invoiceType) =>
    invoiceListTypes.find((item) => item.value === invoiceType);

  const getSelectedInvoiceList = () => {
    const currentSelectedItems: any = selectedItems;
    if (Array.isArray(currentSelectedItems)) {
      return currentSelectedItems.length === 1 ? currentSelectedItems[0] : null;
    }
    return currentSelectedItems?.id ? currentSelectedItems : null;
  };

  useEffect(() => {
    RegisterInvoiceService.getUsingList({
      maxResultCount: 1000,
      Sorting: "creationTime",
      SortType: "DESCEND",
    }).then(({ items }) => {
      const nextRegisterInvoices = (items || []).map((item) => ({
          ...item,
          label: `${item.symbolCode} - ${item.invoiceTypeName}`,
        }));
      setRegisterInvoices(nextRegisterInvoices);
    });
    CurrencyService.getList({ maxResultCount: 1000 }).then(({ items }) => {
      setCurrencies(items || []);
    });
    InvoiceService.getPaymentTypes().then(({ items }) => {
      setPaymentTypes(
        (items || []).map((item) => ({
          value: item.name,
          label: item.name,
        })),
      );
    });
  }, []);

  const {
    render: renderDataTable,
    refreshLazyData,
    reloadLazyData,
    selectedItems,
  } = useDataTable({
    header,
    dataKey,
    filterDelay: 500,
    columns: [
      {
        field: "invoiceType",
        header: "Loại bảng kê",
        width: 120,
        matchMode: "equals",
        filterType: "dropdown",
        filterOptions: invoiceListTypes,
        dataType: "custom",
        customCell(rowData: any): any {
          const invoiceType = getListType(rowData.invoiceType);
          return (
            <span className={`ss04-status ss04-status-${rowData.invoiceType}`}>
              {invoiceType?.label}
            </span>
          );
        },
      },
      {
        field: "status",
        header: "Trạng thái gửi CQT",
        width: 150,
        matchMode: "equals",
        filterType: "dropdown",
        filterOptions: statuses,
        dataType: "custom",
        customCell(rowData: any): any {
          const status = getStatus(rowData.status);
          return (
            <span
              className={`send-tax-status send-tax-status-${rowData.status}`}
            >
              {status?.label}
            </span>
          );
        },
      },
      
      {
        field: "invoiceListSerial",
        header: "Ký hiệu mẫu số bảng kê",
        width: 200,
        dataType: "custom",
        customCell(rowData: any): any {
          return rowData.invoiceListSerial || "01/BK-ĐCTT";
        },
      },
      {
        field: "invoiceListNumber",
        header: "Số bảng kê",
        width: 140,
        matchMode: "contains",
      },
      {
        field: "invoiceListDate",
        header: "Ngày bảng kê",
        width: 120,
        matchMode: "equals",
        filterType: "range-date",
        filterField: "invoiceListDate@invoiceListDate",
        dataType: "date",
      },
      {
        field: "invoiceSerial",
        header: "Ký hiệu",
        width: 120,
        matchMode: "contains",
      },
      {
        field: "invoiceNumber",
        header: "Số hóa đơn",
        width: 120,
        matchMode: "contains",
        dataType: "custom",
        filterType: "number",
        customCell(rowData: any): any {
          return (
            <span
              className={rowData.invoiceId ? "underline text-primary" : ""}
              onClick={() => {
                if (!rowData.invoiceId) {
                  return;
                }
                setInvoiceStatus(null);
                InvoiceService.getDetail(rowData.invoiceId).then((invoice) => {
                  setSelectedInvoice(invoice);
                  setRegisterInvoice(
                    registerInvoices.find(
                      (item) => item.id === invoice.registerInvoiceId,
                    ) || null,
                  );
                  const canEdit = ![2, 3, 4, 5].includes(
                    invoice.sendTaxStatus,
                  );
                  setShowIconSign(canEdit);
                  setDisplayCrup(true);
                });
              }}
            >
              {rowData.invoiceNumber}
            </span>
          );
        },
        style: { justifyContent: "center" },
      },
    
      {
        field: "invoiceDate",
        header: "Ngày lập HĐĐC/TT",
        width: 200,
        matchMode: "equals",
        filterType: "range-date",
        filterField: "invoiceDate@invoiceDate",
        dataType: "date",
      },
      {
        field: "buyer",
        header: "Tên đơn vị mua",
        minWidth: 180,
        matchMode: "contains",
      },
      {
        field: "buyerTaxCode",
        header: "Mã số thuế",
        width: 130,
        matchMode: "contains",
      },
      {
        field: "buyerAddress",
        header: "Địa chỉ",
        minWidth: 180,
        matchMode: "contains",
      },
      {
        field: "creatorName",
        header: "Người tạo",
        width: 120,
        matchMode: "contains",
      },
      {
        field: "creationTime",
        header: "Ngày tạo",
        width: 120,
        matchMode: "equals",
        filterType: "range-date",
        filterField: "creationTime@creationTime",
        dataType: "date",
      },
    ],
    indexColumnWidth: 40,
    getList: (params) => InvoiceListService.getList(params),
  });

  const print = (rowData) => {
    setPdf(InvoiceListService.getPdfUrl(rowData.id));
    setDisplayPdf(true);

    LoadingService.start();
  };

  const { renderSign, sign } = useSign({ onComplete: reloadLazyData });

  const handleSign = async (plugCommand) => {
    const invoice = plugCommand?.InvoiceIdArray?.[0];
    const invoiceId = typeof invoice === "string" ? invoice : invoice?.id;

    if (!invoiceId) {
      ConfirmDialogService.showInvalid(
        "Không tìm thấy ID hóa đơn hợp lệ để ký.",
      );
      return;
    }

    if (typeof invoice !== "string" && !invoice?.signOnly) {
      const serverTime = await ServerTimeService.getList({});
      const time = moment(serverTime.time);
      const invoiceDate = moment(invoice?.invoiceDate);
      const diffInDays = time.diff(invoiceDate, "days");

      if (diffInDays >= 2) {
        ConfirmDialogService.setProps({
          className: "w-6",
          message: (
            <div>
              Theo quy định tại Khoản 7, Phụ lục "Nội dung của hóa đơn" Nghị
              định 254/2026/NĐ-CP, thời điểm ký gửi dữ liệu hóa đơn lên CQT chậm
              nhất là ngày làm việc tiếp theo kể từ thời điểm lập hóa đơn. Hóa
              đơn đang ký có ngày lập{" "}
              <b>{invoiceDate.format("DD/MM/YYYY")}</b>, ký hiệu{" "}
              <b>{invoice?.invoiceSerial}</b>, số{" "}
              <b>{invoice?.invoiceNumber}</b> không thỏa mãn quy định trên. Bạn
              có muốn tiếp tục thao tác ký gửi không?
            </div>
          ),
          header: "Cảnh báo ký gửi hóa đơn sai thời điểm",
          icon: "pi pi-info-circle",
          acceptClassName: "p-button-danger",
          acceptLabel: "Có, tiếp tục ký",
          rejectLabel: "Không",
          accept: () => {
            sign({
              CommandName: "SignInvoices",
              InvoiceIdArray: [invoiceId],
            });
          },
        });
        return;
      }
    }

    sign({
      CommandName: "SignInvoices",
      InvoiceIdArray: [invoiceId],
    });
  };

  const printSelected = () => {
    const selectedInvoiceList = getSelectedInvoiceList();
    if (!selectedInvoiceList) {
      ConfirmDialogService.showInvalid("Bạn cần chọn một bảng kê trước khi Xem in");
      return;
    }
    print(selectedInvoiceList);
  };

  const downloadXml = (rowData) => {
    InvoiceListService.downloadXml(rowData.id).then((data) => {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `${rowData["taxCode"]}_04_ss-HDDT.xml`;
      link.click();
    });
  };

  const showLinkedStatementWarning = (detail: string) => {
    ConfirmDialogService.showInvalid(detail);
  };

  const { renderToolbar } = useToolbar({
    dataKey,
    update: (item) => {
      if (isInvoiceLinkedStatement(item)) {
        showLinkedStatementWarning(linkedStatementMessages.edit);
        return;
      }
      setInvoiceListRequiredParams((currentParams) => ({
        ...currentParams,
        InvoiceType: Number(item.invoiceType),
      }));
      setSelectedInvoiceListId(item.id);
      setDisplayBangKe(true);
    },
    reloadLazyData,
    selectedItems,
    otherActions: [
      {
        label: "Xem in",
        icon: "pi pi-fw pi-print",
        className: "iam-toolbar iam-toolbar-success",
        command: printSelected,
        disabled: !getSelectedInvoiceList(),
      },
    ],
    validateDeleteItems: (items) => {
      const selectedInvoiceLists = Array.isArray(items) ? items : [items];
      if (selectedInvoiceLists.some(isInvoiceLinkedStatement)) {
        showLinkedStatementWarning(linkedStatementMessages.delete);
        return false;
      }
      return true;
    },
    deleteItem: (id) => {
      return InvoiceListService.delete(id);
    },
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderSign()}
      <Dialog
        header="Xem in bảng kê"
        visible={displayPdf}
        style={{ width: "90vw" }}
        draggable={false}
        resizable={true}
        position="top"
        onHide={() => {
          setDisplayPdf(false);
          setPdf(null);
          LoadingService.stop();
        }}
      >
        <iframe
          src={pdf}
          title="invoice-list-preview"
          style={{ width: "100%", height: "75vh", border: 0 }}
          onLoad={() => LoadingService.stop()}
        />
      </Dialog>
      <DialogCrup
        display={displayCrup}
        setDisplay={setDisplayCrup}
        reloadLazyData={reloadLazyData}
        registerInvoices={registerInvoices}
        currencies={currencies}
        paymentTypes={paymentTypes}
        registerInvoice={registerInvoice}
        selectedItem={selectedInvoice}
        invoiceStatus={invoiceStatus}
        setInvoiceStatus={setInvoiceStatus}
        relatedInvoiceProperty={selectedInvoice?.relatedInvoiceProperty}
        setSelectedItems={setSelectedInvoice}
        sign={handleSign}
        showIconSign={showIconSign}
        showSave={showIconSign}
        invoiceListReviewOnly
      />
      <DialogBangKe
        display={displayBangKe}
        invoiceListId={selectedInvoiceListId}
        invoiceType={invoiceListRequiredParams.InvoiceType}
        registerInvoices={registerInvoices}
        setSelectedInvoiceListId={setSelectedInvoiceListId}
        setDisplay={setDisplayBangKe}
        onSubmit={() => {
          setDisplayBangKe(false);
          reloadLazyData();
        }}
      />
    </Fragment>
  );
};
